import { TERMS_HTML, TERMS_VERSION } from "@/content/legal/versions";

export default function TermsPage() {
  return (
    <div className="container mx-auto max-w-3xl px-4 py-12">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">Términos y Condiciones de Uso</h1>
        <p className="text-sm text-muted-foreground">
          Versión {TERMS_VERSION} · Arcus Learn
        </p>
      </header>
      <article
        className="prose prose-sm max-w-none prose-headings:font-semibold prose-p:leading-relaxed"
        dangerouslySetInnerHTML={{ __html: TERMS_HTML }}
      />
    </div>
  );
}
